<template>
  <l-layout :layout="[ 'xs12']" bottom-space>
    <l-data-table
      :get-data-func="getItems"
      :headers="headers"
      @click:row="goDetails($event.item)"
      clickable
      init-sort-by="name"
      ref="dataTable"
      title-text="机构列表"
      search-text="搜索机构名称"
    >
      <template slot="row-action" slot-scope="{item}">
        <td @click.stop class="px-0 mx-0 text-xs-center">
          <v-btn @click="deleteItem(item)" icon>
            <v-icon small>$vuetify.icons.delete</v-icon>
          </v-btn>
        </td>
      </template>
    </l-data-table>
    <l-fixed-btn
      @click="goNew"
      icon="$vuetify.icons.add"
    ></l-fixed-btn>
  </l-layout>
</template>

<script>
import {time} from '../../../ladmin/utils'

export default {
  name: 'InstitutionList',
  props: ['refresh'],
  data: () => ({
    floatingButton: false,
    headers: [
      {text: '机构名称', value: 'name', align: 'left', placeholder: 'N/A'},
      {text: '机构描述', value: 'description', align: 'right', placeholder: 'N/A', maxWidth: '14em', tooltip: true},
      {text: '上次修订', value: 'lastUpdateTime', align: 'right', placeholder: 'N/A',f: v => time.stringify(v)},
      {text: '修订人员', value: 'lastEditor', align: 'right', placeholder: 'N/A'},

      {text: '', value: '', align: 'right', width: '80px', sortable: false}
    ],
  }),
  methods: {
    async getItems ({pagination, sortStack, filterItems, search}) {
      return this.$store.dispatch('userAdmin/getInstitutions', {
        pagination,
        sortStack,
        filter: filterItems,
        search: {key: 'name', value: search},
      })
    },
    async deleteItem (item) {
      // console.log(user)
      if (!item) return
      let {res, close} = await this.$L.confirm({
        title: '确认删除该机构？',
        text: item.name || `N/A`,
      })
      if (res) {
        try {
          await this.$store.dispatch('userAdmin/deleteInstitutions', [item])
          this.$L.alert('success', {message: '删除成功'})
          this.$refs.dataTable.refresh()
        }
        catch (e) {
          this.$L.alert('error', {message: e.message})
        }
      }
      close()
    },
    goDetails (item, force) {
      let selectionString = document.getSelection().toString()
      if (!selectionString || force) {
        this.$router.push({
          name: 'InstitutionDetails',
          params: {name: item.name},
          query: {id: item.id}
        })
      }
    },
    goNew () {
      this.$router.push({
        name: 'NewInstitution'
      })
    },
  },
  activated () {
    if (this.refresh) {
      this.$refs.dataTable.refresh()
    }
  }
}
</script>

<style scoped>

</style>
